
import { defineComponent } from 'vue';
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue';
import Banner from '@/components/banner/Banner.vue';
import ProductItem from './product/ProductItem.vue';
import { getVehicleTypeList, getVehicleList } from '@/api/apis';

interface ProductProps {
  vehicleTypeList: any[];
  vehicleList: any[];
  oVehicleTypeList: any[];
  [key: string]: any;
}

export default defineComponent({
  name: 'Product',
  components: {
    Banner,
    ProductItem,
    DownOutlined,
    UpOutlined
  },
  data(): ProductProps {
    const selectedType = '';
    return {
      loading: false,
      loaded: false,
      selectedType,
      pageNo: 1,
      pageSize: 6,
      pageSizeOptions: ['6', '12'],
      current: 1,
      total: 0,
      vehicleTypeList: [],
      vehicleList: [],
      oVehicleTypeList: [],
      expand: false
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    toggleVehicleType() {
      this.expand = !this.expand;
      if (this.expand) {
        this.vehicleTypeList = [...this.oVehicleTypeList];
      } else {
        this.vehicleTypeList = this.oVehicleTypeList.slice(0, 7);
      }
    },
    handleTypeChange(vehicleType) {
      if (vehicleType !== this.selectedType) {
        this.selectedType = vehicleType;
        this.loaded = false;

        this.$router.push(`/products?vehicleType=${this.selectedType}`);
      }
    },
    getTitle() {
      const item = this.oVehicleTypeList.find(
        (s: any) => s.vehicleType === this.selectedType
      );
      return item ? this.$t(item.vehicleType) : '';
    },
    async loadData() {
      const res = await getVehicleTypeList();

      if (res.success) {
        this.oVehicleTypeList = res.result || [];
        this.vehicleTypeList = this.oVehicleTypeList.slice(0, 7);

        // 路由
        if (!this.selectedType) {
          if (this.vehicleTypeList.length > 0) {
            this.selectedType = (this.vehicleTypeList[0] as any).vehicleType;
          }
        }

        if (this.selectedType) {
          // await this.loadVehicleList();
          this.$router.push(`/products?vehicleType=${this.selectedType}`);
        }
      }
    },
    async loadVehicleList() {
      this.loading = true;
      const vRes = await getVehicleList({
        vehicleType: this.selectedType,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });

      if (vRes.success) {
        this.vehicleList = vRes.result.records || [];
        this.total = vRes.result.total;
      }

      this.loading = false;

      this.loaded = true;
    },
    onShowSizeChange() {
      this.pageNo = 1;
      this.loadVehicleList();
    },
    onChange() {
      this.loadVehicleList();
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (val.name === 'Products') {
          const vehicleType = val.query.vehicleType;
          this.selectedType = vehicleType;

          if (!this.selectedType) {
            if (this.vehicleTypeList.length > 0) {
              this.selectedType = (this.vehicleTypeList[0] as any).vehicleType;
              this.$router.push(`/products?vehicleType=${this.selectedType}`);
            }
          } else {
            this.loadVehicleList();
          }
        }
      }
    }
  }
});
